import { USER_IS_ENABLED, USER_IS_CONFIRMED, USER_IS_DELETED, FETCH_USER, DESTROY_USER } from "../actionTypes";
export const fetchUser = users => ({
  type: FETCH_USER,
  users
});

export const editUserIsEnabled = (id, isEnable) => ({
  type: USER_IS_ENABLED,
  id,
  isEnable
});

export const editUserIsConfirmed = (id, isConfirmed) => ({
  type: USER_IS_CONFIRMED,
  id,
  isConfirmed
});

export const editUserIsDeleted = (id, isDeleted) => ({
  type: USER_IS_DELETED,
  id,
  isDeleted
});

export const destroyUser = key => ({
  type: DESTROY_USER,
  key
});